import { createContext, useState } from "react";
import LeakedPasswordIcon from "../components/svg/LeakedPasswordIcon";
import ExposedDomainIcon from "../components/svg/ExposedDomainIcon";
import ExposedIpIcon from "../components/svg/ExposedIpIcon";
import PotentialVulnerabilityIcon from "../components/svg/PotentialVulnerabilitieIcon";
import PotentialMalwareIcon from "../components/svg/PotentialMalwareIcon";
import { NotificationItemProps } from "../types/components/NotificationItemProps";

interface NotificationContextProps {
  notificationList: NotificationItemProps[];
  removeNotificationItem: (notificationToRemove: NotificationItemProps) => void;
}

export const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const NotificationProvider = (props: { children: React.ReactNode }) => {
  // Example of list notifications
  const [notificationList, setNotificationList] = useState<NotificationItemProps[]>([
    {
      icon: <LeakedPasswordIcon />,
      path: "#",
      title: "New Leaked Password",
      subtitle: "Go there and verify.",
    },
    {
      icon: <ExposedDomainIcon />,
      path: "#",
      title: "New Exposed Domain",
      subtitle: "Go there and verify.",
    },
    {
      icon: <ExposedIpIcon />,
      path: "#",
      title: "New Exposed IP",
      subtitle: "Go there and verify.",
    },
    {
      icon: <PotentialVulnerabilityIcon />,
      path: "#",
      title: "New Potential Vulnerabilitie",
      subtitle: "Go there and verify.",
    },
    {
      icon: <PotentialMalwareIcon id="notification_potentialmalware_icon" />,
      path: "#",
      title: "New Potential Malware",
      subtitle: "Go there and verify.",
    },
  ]);

  // remove notification item
  const removeNotificationItem = (notificationToRemove: NotificationItemProps) => {
    // Filter out the specified notification object from the array
    const updatedNotifications = notificationList.filter((Notificationitem) => Notificationitem !== notificationToRemove);
    setNotificationList(updatedNotifications);
    // Then Do Something in back-end service...
  };

  return (
    <NotificationContext.Provider value={{ notificationList, removeNotificationItem }}>
      {props.children}
    </NotificationContext.Provider>
  );
};
